import { PopUpMessageContext } from '@hb/react'
import { Auth } from 'firebase/auth'
import { useContext, useEffect } from 'react'
import { registerAuthListener, registerRedirectResultListener } from '../../../backend/auth/signIn'

export const useAuthListeners = (auth: Auth) => {
  const { showError, showSuccess, showInfo } = useContext(PopUpMessageContext)
  useEffect(
    () => registerAuthListener(auth, showSuccess, showError, showInfo),
    [showError, showSuccess, showInfo, auth],
  )

  useEffect(() => {
    registerRedirectResultListener(auth, showSuccess, showError, showInfo)
  }, [showError, showSuccess, showInfo, auth])
}
